import Component from './Component';

export default class ModalGallery extends Component {
  load() {
    this.init();
    super.load();
  }

  init() {
    // console.log('ModalGallery init');

    $(".imagegrid").on('click', () => {
      console.log('clicked');
      $('#galleryModal').modal('toggle');
      // $('#galleryModal').removeClass('fade');
      // $('#galleryModal').show();
    })
  }
}
